import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"font-size":"12px"},
  class: "col-10 col-offset-1 text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, "Copyright © 2021-" + _toDisplayString(_ctx.current) + " Zumasys Inc.", 1))
}